export default __webpack_public_path__ + "static/media/manicurehybrydowyprzed.ac48c483.jpeg";